// src/components/Home/Home.js
import React from 'react';
import Hero from '../../components/hero/hero';
import Abouts from '../../components/about/Abouts';
import Work from '../../components/work/work';

function Home() {
  return (
    <div className="Home">
      <Hero />
      <Abouts />
      <Work />
    </div>
  );
}

export default Home;